document.addEventListener('DOMContentLoaded', function () {
    var swiper_el = document.querySelector('#reviewsCarousel');

    const swiper = new Swiper('.reviewSwiper', {
        slidesPerView: 1,
        spaceBetween: 10,

        breakpoints: {
            640: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            // when window width is >= 640px
            1000: {
            slidesPerView: 2,
            spaceBetween: 30
            }
        },
        autoplay: {
            pauseOnMouseEnter: true
        },
        loop: true,
        on: {
            afterInit: function() {
                swiper_el.classList.remove('is-loading');
                swiper_el.classList.add('is-ready');
            },
        },
});
});
 

        